<template>
  <div id="app">
    <router-view/>
    <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import EventBus from '@/services/eventBus.js'
export default {
  name: 'App',
  components: {
    Loading
  },
  created(){
    EventBus.$on('startLoading', _=>{
      this.isLoading = true;
    });
    EventBus.$on('dismissLoading', _=>{
      this.isLoading = false;
    });
  },
  data(){
    return{
      isLoading:false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue